// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"103":"4dc9b6c4","453":"758d3e08","638":"79dd187c"}[chunkId] + ".chunk.js";
};